import React from 'react';
import ReactDOM from 'react-dom';

import reportWebVitals from './reportWebVitals';

import "./App.css"
import Layout from './Layout/Layout'

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Layout/>,
    document.body.appendChild(document.createElement('div')),
  )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
